import { format } from 'owa-localize';

const PDFJS_PREVIEW_URL_TEMPLATE: string = '/owa/{0}/service.svc/s/GetAttachmentPdfPreview?id={1}';

export default async function getAttachmentPdfPreviewResponse(
    routingKey: string,
    attachmentId: string
): Promise<Response> {
    const url = format(PDFJS_PREVIEW_URL_TEMPLATE, routingKey, encodeURIComponent(attachmentId));
    const response: Response = await fetch(url, { credentials: 'same-origin' });
    return response;
}
